// import IndexStep from "../../../../../App/Courses/Declaration/IndexStep";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";
// import Client from "../../../../../Objects/models/Client";
import { SET_COURSE_DECLARATION_INFO } from "../../../../../Redux/Reducers/DeclarationCourseReducers";
import { paragraphe } from "../../../../../Styles/Style";
import punctualCourseImg from "../../../../../Assets/Images/cours_ponctuel.png";
import urgentCourseImg from "../../../../../Assets/Images/cours_en urgence.png";
// import type { DataChildType, DataDisptachType } from "../../CourseDeclare";
import ChildRepository from "../../../../../Repositories/ChildRepository";
import { courseTypes } from "../../staticData";
import IndexStep from "../../../../../App/DeclarationCourse/IndexStep";

type Props = {
	client?: Client;
	generalStep: any;
	handleChangeStep: (val: number) => void;
	dataChild: DataChildType;
	dataDispatch: DataDisptachType;
}

export default function FirstStep({ client, dataChild, dataDispatch, generalStep, handleChangeStep }: Props) {
	const dispatch = useDispatch();

	// const dateTimeTdpMomentRef = useRef(new Date())
	// const radioGroupRef = React.useRef<HTMLElement>(null);

	const [stepInfo, setStepInfo] = useState({
		openChildrenListDialog: false,
		openCreateChildDialog: false,
		errorMsg: "",
		load: false,
		// value: client?.id?.toString(),
		child: generalStep?.firstStep?.child || null
	})

	// TODO: configurer l'ajout d'un proche
	const { data: dataChildren, isLoading: isLoadingChildren } = useQuery({
		queryKey: [client?.id, 'user-relatives'],
		queryFn: () => ChildRepository
			.getChildren(client!.id!)
			.then(data => {
				if (!stepInfo.child) {
					const loggedUserAsChild = data.find(child => child.firstName === client?.firstName)
					setStepInfo(curr => ({ ...curr, child: loggedUserAsChild }))
					dispatch({
						type: SET_COURSE_DECLARATION_INFO,
						payload: {
							...generalStep,
							firstStep: {
								...generalStep?.firstStep,
								// childId: parseInt(loggedUserAsChild?.id),
								child: loggedUserAsChild || null,
							},
							step: generalStep?.secondStep ? 2 : 1
						}
					});
				}
				return data
			}),
		enabled: !!client?.id
	})

	// const handleOpenChildrenList = () => { setStepInfo({ ...stepInfo, openChildrenListDialog: true }) };
	// const handleOpenCreateChild = () => { setStepInfo({ ...stepInfo, openCreateChildDialog: true }) };

	const handleCloseChildrenList = () => {
		setStepInfo({ ...stepInfo, openChildrenListDialog: false })
		dataChild.search.setNameSearch("")
	};

	// const handleCloseCreateChild = () => {
	// 	setStepInfo({ ...stepInfo, openCreateChildDialog: false })
	// };

	const handleSubmit = () => {
		if (stepInfo.child) {
			setStepInfo({ ...stepInfo, errorMsg: "" });
			handleCloseChildrenList();
			dispatch({
				type: SET_COURSE_DECLARATION_INFO,
				payload: {
					...generalStep,
					firstStep: {
						child: stepInfo.child,
					},
					step: generalStep?.secondStep ? 2 : 1
				}
			});
		}
	};

	const handleNextStep = (value: number, isMonth: boolean, courseType: keyof typeof courseTypes) => {
		const payload = {
			...generalStep,
			step: value,
			courseType,
			cours: isMonth
		};

		dispatch({
			type: SET_COURSE_DECLARATION_INFO,
			payload
		});
		handleChangeStep(value);
	}

	const handleSearch = (value: string) => {
		dataDispatch.setCurrentPage(0)
		dataChild.search.setNameSearch(value)
	}

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setStepInfo(curr => ({ ...curr, child: dataChildren?.find(child => child.id === Number(event.target.value)) }))
	};

	// const handleSelectChild = (child: Child) => setStepInfo({ ...stepInfo, child })

	// const displayChildrenListBody = () => {
	// 	return (
	// 		<div className="">
	// 			<div className="relative w-full flex items-center shadow-md bg-transparent rounded-lg border mb-4 py-2">
	// 				<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
	// 					<SearchTwoToneIcon className="w-5 h-5 mr-2" />
	// 				</div>
	// 				<input
	// 					type="text"
	// 					id="simple-search"
	// 					className="text-sm font-semibold block w-full pl-10 rounded-lg"
	// 					placeholder={`Filtrer par ${isBrandActive(ENV_TEACHR) ? "élève": "client"}`}
	// 					onChange={(e) => handleSearch(e.target.value)}
	// 					value={dataChild.search.nameSearch}
	// 				/>
	// 				<HighlightOffTwoToneIcon
	// 					className={`w-5 h-5 mr-2 ${dataChild.search.nameSearch ? "" : "hidden"}`}
	// 					onClick={() => dataChild.search.setNameSearch("")}
	// 				/>
	// 			</div>
	// 			<FormControl>
	// 				<RadioGroup
	// 					ref={radioGroupRef}
	// 					aria-label="ringtone"
	// 					name="ringtone"
	// 					value={stepInfo.child?.id}
	// 					onChange={handleChange}
	// 				>
	// 					<List dense className="border rounded-md lg:w-[470px]" sx={{ width: '100%', bgcolor: 'background.paper' }}>
	// 						{dataChildren?.map((child) => {
	// 							return (
	// 								<ListItem
	// 									// className={`flex items-center justify-between ${firstCondition ? "bg-gray-100" : ""}`}
	// 									className="flex items-center justify-between bg-gray-100"
	// 									key={child?.id}
	// 									secondaryAction={
	// 										<FormControlLabel
	// 											// onClick={() => handleSelectChild(child)}
	// 											value={child?.id}
	// 											label={""}
	// 											control={
	// 												<BpRadio
	// 													className="text-first"
	// 													// disableRipple
	// 													// color="default"
	// 													// checkedIcon={<BpCheckedIcon />}
	// 													// icon={<BpIcon />}
	// 												/>
	// 											}
	// 										/>
	// 									}
	// 									disablePadding
	// 								>
	// 									<ListItemButton>
	// 										<span className='font-nunito text-pretty break-words whitespace-pre-wrap max-w-xs'> {child?.firstName} {child?.lastName}</span>
	// 									</ListItemButton>
	// 								</ListItem>
	// 							);
	// 						})}
	// 					</List>
	// 				</RadioGroup>
	// 			</FormControl>
	// 		</div>
	// 	);
	// };

	const displayComponent = () => {
		return (
			<div className="space-y-8 w-full h-[100%] relative lg:p-0 p-2">
				<div className="font-bold lg:text-lg md:text-base text-sm space-y-6 w">
					<p className="text-normal ">
						Dans cette section, vous pouvez déclarer tous les cours dispensés aux
						élèves pour le mois actuel, ou bien déclarer un cours spécifique qui a
						eu lieu de manière ponctuelle.
					</p>
					<p className="text-third">{stepInfo.errorMsg}</p>
				</div>
				<p className="text-first font-bold lg:text-lg md:text-base text-sm">
					De quel type de cours s’agit-il ?
				</p>
				<div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-y-0 gap-y-6 gap-x-4">
					<button
						onClick={() => {
							handleSubmit();
							handleNextStep(2, false, "punctual")
						}}
						className={`shadow-md flex py-2 items-center border flex-shrink-0 font-bold text-first /bg-inputColor rounded-lg p-2 `}
					>
						<img src={punctualCourseImg} alt="Cours ponctuel" className="w-12 h-12 mr-2" />
						<div className="text-left">
							<p className={paragraphe}>Cours ponctuel</p>
							<p className="text-grey lg:text-sm text-xs">Un seul cours, à la carte</p>
						</div>
					</button>
					<button
						onClick={() => {
							handleSubmit();
							handleNextStep(2, true, "urgent")
						}}
						className={`shadow-md flex py-2 items-center border flex-shrink-0 font-bold text-first /bg-inputColor rounded-lg p-2 `}
					>
						<img src={urgentCourseImg} alt="Cours ponctuel" className="w-12 h-12 mr-2" />
						<div className="text-left">
							<p className={paragraphe}>Cours en urgence</p>
							<p className="text-grey lg:text-sm text-xs">Prenez un cours dans l'heure</p>
						</div>
					</button>
				</div>
			</div>)

	}

	return (
		<IndexStep
			title={"Déclaration de cours 📚"}
			isHere={true}
			body={
				displayComponent()
			}
			value={2}
			step={1}
		/>
	)
}